import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'have_race_ethnic_group_skin_color_sex_gender_1'

export const dataPointDefinition = {
  retracedId: 'have_race_ethnic_group_skin_color_sex_gender_1',
  name: 'Have race, ethnic group, skin color, sex (gender), religion, political opinion, national extraction, social origin, HIV/',
  description:
    'Answer Yes if hiring decisions are based on any of these elements in a manner that is not in line with applicable legal requirements. ',
  meta: {
    slcpMeta: {
      key: 'rh-dis-45',
      number: 'RH-DIS-3',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-dis-45', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34310,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
